// import Vue from 'vue';
import axios from 'axios';

let revampAPI = null;
let routerVue = null;
let storeVue = null;
const revampAPIService = {
  init(url, router, store) {
    revampAPI = axios.create({
      baseURL: url,
      timeout: 60000,
      headers: {
        // 'X-Paxel-API-Key': '',
        // 'X-Paxel-Signature': '',
        'Content-Type': 'application/json',
      },
    });
    routerVue = router;
    storeVue = store;
    revampAPI.interceptors.response.use((response) => response, (error) => {
      if (error.response.status === 401) {
        const loggedIn = routerVue.app.$session.exists();
        if (loggedIn) {
          const token = routerVue.app.$session.get('jwt');
          const expiredUnixTime = JSON.parse(atob(token.split('.')[1])).exp;
          const currentDateTime = new Date();
          const expiredDateTime = new Date(expiredUnixTime * 1000);
          if (currentDateTime > expiredDateTime) {
            storeVue.dispatch('logout');
            routerVue.app.$session.destroy();
            routerVue.push({
              path: '/login',
            });
          }
        }
      }
      return Promise.reject(error);
    });
  },
  get(resource, token = '') {
    // revampAPI.defaults.headers['X-Paxel-API-Key'] = apiKey;
    // revampAPI.defaults.headers['X-Paxel-Signature'] = signature;
    revampAPI.defaults.headers.common.Authorization = `Bearer ${token}`;
    return revampAPI.get(resource);
  },
  post(resource, data, token = '') {
    // revampAPI.defaults.headers['X-Paxel-API-Key'] = apiKey;
    // revampAPI.defaults.headers['X-Paxel-Signature'] = signature;
    revampAPI.defaults.headers.common.Authorization = `Bearer ${token}`;
    return revampAPI.post(resource, data);
  },
  put(resource, data, token) {
    // revampAPI.defaults.headers['X-Paxel-API-Key'] = apiKey;
    // revampAPI.defaults.headers['X-Paxel-Signature'] = signature;
    revampAPI.defaults.headers.common.Authorization = `Bearer ${token}`;
    return revampAPI.put(resource, data);
  },
  delete(resource, token = '') {
    // revampAPI.defaults.headers['X-Paxel-API-Key'] = apiKey;
    // revampAPI.defaults.headers['X-Paxel-Signature'] = signature;
    revampAPI.defaults.headers.common.Authorization = `Bearer ${token}`;
    return revampAPI.delete(resource);
  },
};

export default revampAPIService;
